define('AwaLabs.FooterCopyright', [
    'FooterCopyright.View'
], function FooterCopyright(
    FooterCopyrightView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var childView;
            if (layout) {
                childView = {
                    'FooterCopyright': {
                        'FooterCopyright': {
                            childViewIndex: 1,
                            childViewConstructor: function footerCopyright() {
                                return new FooterCopyrightView({});
                            }
                        }
                    }
                };
                layout.addChildViews('Footer.View', childView);
                if (container.name === 'Checkout') {
                    layout.addChildViews('Footer.Simplified.View', childView);
                }
            }
        }
    };
});
